import { library } from '@fortawesome/fontawesome-svg-core'
import { faIcons } from '#shared/types/generated-icons.ts'

export default defineNuxtPlugin(() => {
  library.add(faIcons)
})
